import { render, staticRenderFns } from "./confirmDelivery.vue?vue&type=template&id=d3966a1e&scoped=true&"
import script from "./confirmDelivery.vue?vue&type=script&lang=js&"
export * from "./confirmDelivery.vue?vue&type=script&lang=js&"
import style0 from "./confirmDelivery.vue?vue&type=style&index=0&id=d3966a1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3966a1e",
  null
  
)

export default component.exports